import { Button, Empty, Flex, List, Popconfirm, Space, Tag, Typography, theme } from 'antd';
import { FC, ReactElement, useState } from 'react';
import { ExclamationCircle, PersonVcard, Trash } from 'react-bootstrap-icons';

import { CopyableText } from '@/common/components';

import { DomainRegistrarAccount, DomainRegistrarsAccountHiddenPassword } from '@/modules/DomainRegistrars';

interface Props {
  domainRegistrarAccountsDataSource: DomainRegistrarAccount[];
  disableControlButtons: boolean;
  handleDeleteAccount: (accountId: string) => void;
}

const { Text } = Typography;

export const DomainRegistrarAccountsListView: FC<Props> = ({
  domainRegistrarAccountsDataSource,
  disableControlButtons,
  handleDeleteAccount,
}: Props) => {
  const { token } = theme.useToken();
  const [editableRowKey, setEditableRowKey] = useState<string | null>(null);

  return (
    <div style={{ overflowY: 'auto', maxHeight: 760, marginInline: -24, paddingInline: 24 }}>
      <List
        className="app-list"
        dataSource={domainRegistrarAccountsDataSource}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Немає акаунтів" />,
        }}
        header={
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky',
            }}
          >
            <Text strong>
              Доступи до реєстратора <Tag color="blue">{domainRegistrarAccountsDataSource.length}</Tag>
            </Text>
            {<PersonVcard size={22} />}
          </div>
        }
        renderItem={(item): ReactElement => (
          <List.Item
            extra={
              <Space size="small">
                {/* <Button
                  type="text"
                  disabled={ disableControlButtons }
                  onClick={ (): void => setEditableRowKey(item.id) }
                  icon={ <Pencil/> }
                /> */}
                <Popconfirm
                  destroyTooltipOnHide
                  title="Видалити акаунт"
                  icon={<ExclamationCircle color={token.colorError} />}
                  description="Ви дійсно хочете видалити цей акаунт?"
                  onConfirm={(): void => handleDeleteAccount(item.id)}
                  okText="Так, видалити"
                  okButtonProps={{ danger: true }}
                  cancelText="Ні"
                  placement="topLeft"
                  disabled={disableControlButtons}
                >
                  <Button type="text" danger disabled={disableControlButtons} icon={<Trash />} />
                </Popconfirm>
              </Space>
            }
          >
            <List.Item.Meta
              title={
                <>
                  <Text type="secondary" style={{ fontWeight: 400, wordBreak: 'keep-all' }}>
                    Логін:&nbsp;
                  </Text>
                  <CopyableText textToCopy={item.login} style={{ maxWidth: 265, width: '100%' }}>
                    {item.login}
                  </CopyableText>
                  <br />
                  <Flex align="center" wrap={false}>
                    <Text type="secondary" style={{ fontWeight: 400, wordBreak: 'keep-all' }}>
                      Пароль:&nbsp;
                    </Text>
                    <DomainRegistrarsAccountHiddenPassword
                      domainRegistrarId={item.domainRegistrarId}
                      domainRegistrarAccountId={item.id}
                    />
                  </Flex>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

/* <ProList
rowKey="id"
dataSource={ domainRegistrarAccountsDataSource }
editable={{
  deletePopconfirmMessage: 'Ви дійсно хочете видалити цей акаунт?',
  saveText: 'Зберегти',
  cancelText: 'Скасувати',
  deleteText: 'Видалити',
  formProps: { layout: 'vertical', wrapperCol: { span: 24 } },
  actionRender: (_, __, defaultDoms) => [
    <Space key="extra" direction="horizontal">
      { defaultDoms.save }
      { defaultDoms.delete }
      { defaultDoms.cancel }
    </Space>
  ],
  onSave: async (key, record, originRow) => {
    console.log(key, record, originRow);
    setIsRowEditable(false);
    return true;
  },
  onCancel: (): void => {
    setIsRowEditable(false);
  },
  onDelete: (): void => {
    setIsRowEditable(false);
  }
}}
itemLayout={ isRowEditable ? 'vertical' : 'horizontal' }
bordered
metas={{
  title: {
    fieldProps: { allowClear: true },
    formItemProps: { label: 'Логін', required: true, rules: domainRegistrarAccountFormValidationSchema.Login },
    dataIndex: 'login'
  },
  description: {
    fieldProps: { allowClear: true, inputRender: false, rows: 1, autoSize: false },
    formItemProps: {
      label: 'Пароль',
      required: true,
      rules: domainRegistrarAccountFormValidationSchema.Password
    },
    dataIndex: 'password'
  },
  actions: {
    render: (text, row, index, action) => [
      <Button
        key="edit"
        type="text"
        onClick={ (): void => {
          action?.startEditable(row.id);
          setIsRowEditable(true);
        } }
        icon={ <Pencil/> }
      />
    ]
  }
}}
/> */
